import { AxiosInstance } from "axios"
import { ReportDetails } from "../../../merchant/controlKitchenApi"
import { OrderForCalendar } from "../../../merchant/merchant/production/ordersForCalendar/ordersForCalendarTypes"

export type ServiceCenterAdminsParams = Readonly<{
    serviceCenterId: number
    startDate: string
    endDate: string
}>

export type FetchServiceCenterCalendarEventsResponse = Readonly<{
    reportDetails: ReportDetails | any
    orders: OrderForCalendar[]
}>

export enum ServiceCenterCalendarQuery {
    EVENTS = "meeting-service-center-calendar-events",
}

export async function fetchServiceCenterCalendarEvents(
    { serviceCenterId, startDate, endDate }: ServiceCenterAdminsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchServiceCenterCalendarEventsResponse> {
    const url = `/serviceCenters/${serviceCenterId}/events`

    const response = await axios.get(url, {
        params: {
            startDate,
            endDate,
        },
        signal,
    })

    return response.data
}
